import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Component, ViewEncapsulation, Output, EventEmitter, OnDestroy, Input, ViewChild } from '@angular/core';

import { User } from './../../models/User';
import { ModalComponent } from './../modal/modal.component';
import { AppState } from './../../interfaces/app-state.interface';
import { StorageService } from './../../services/storage.service';
import { AgreementsAction } from './../../state-management/agreements/agreements.action';
import { SuitabilityAction } from './../../state-management/suitability/suitability.action';
import { SuitabilityProfilesEnum } from '../../enum/suitability/suitability-profiles.enum';
import { UserProfileActions } from './../../state-management/userprofile/userprofile.actions';
import { SuitabilityProfileModel } from './../../models/suitability/suitabilityProfile.model';
import { ImportedBy } from '../../enum/user/importedby';

const MINIMUM_AGREEMENT_REQUIRED = 4;

interface IToroPi {
    isAgreement: boolean;
    isSuitability: boolean;
    firstLogin: string;
    isShowMovie: boolean;
}

// TODO: implementação temporária, remover após clientes Pi concluído suitability e agreement fernando.souza
@AutoUnsubscribe()
@Component({
    selector: `modal-welcome-pi`,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './modal-welcome-pi.component.html',
    styleUrls: ['./modal-welcome-pi.component.scss'],
})

// TODO: implementação temporária, remover após clientes Pi concluído suitability e agreement fernando.souza
export class ModalWelcomePiComponent implements OnDestroy {

    @ViewChild('modalWelcomePi', { static: true })
    public modalWelcomePi: ModalComponent;

    @Output() public onSendStatus: EventEmitter<IToroPi> = new EventEmitter();

    @Output() public hideModal: EventEmitter<boolean> = new EventEmitter();

    @Input() public isRenderFirstLogin: string = 'no';

    @Input() public set showModal(show: boolean) {
        if (show) this.modalWelcomePi.show();
    }

    public user: User;
    public suitability: SuitabilityProfileModel = new SuitabilityProfileModel();
    public agreementsAccepted: any[] = [];
    public integrationToroPi: IToroPi = {
        isAgreement: true,
        isSuitability: true,
        firstLogin: 'yes',
        isShowMovie: false,
    };
    private isOpenedModal: boolean = false;

    constructor(
        private store: Store<AppState>,
        private router: Router,
    ) {

        this.store.dispatch({ type: UserProfileActions.getUser });
        this.store.dispatch({ type: AgreementsAction.getAgreementStatus });
        this.store.dispatch({ type: SuitabilityAction.getProfile });

    }

    public ngOnInit() {

        this.store
            .select(({ userProfile }) => userProfile.user)
            .combineLatest(
                this.store.select(({ suitability }) => suitability),
                this.store.select(({ agreements }) => agreements),
            )
            .filter(([{ profile }, suitability, { acceptedAgreements }]) => !!profile && !!suitability.profile && !!acceptedAgreements)
            .take(1)
            .subscribe(([user, { profile }, { acceptedAgreements }]) => {

                this.user = user;
                this.agreementsAccepted = acceptedAgreements;
                this.suitability.profile = profile.profile;

                this.storageToroPi();
                this.validateWelcomePi();
            });

    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line:no-empty
    public ngOnDestroy() { }

    /**
     * Valida usuarios tombados Pi para Toro para preenchimentos de docs
     */
    public validateWelcomePi() {

        const isImportedBy = this.user.importedBy === ImportedBy.Pi || this.user.importedBy === ImportedBy.UpdatedPi;

        if (!isImportedBy) return;

        this.integrationToroPi.isAgreement = !!this.agreementsAccepted && this.agreementsAccepted.length >= MINIMUM_AGREEMENT_REQUIRED;
        this.integrationToroPi.isSuitability = this.suitability.profile !== SuitabilityProfilesEnum.NoProfile;

        if ((!this.integrationToroPi.isAgreement || !this.integrationToroPi.isSuitability) && !this.isOpenedModal) {
            this.modalWelcomePi.show();
            StorageService.setLocalItem('@common:is_show_movie_toro_pi', 'yes');
            this.isOpenedModal = true;
        } else if (this.integrationToroPi.isAgreement && this.integrationToroPi.isSuitability && !this.isOpenedModal) {
            this.showMovieToroPi();
            this.isOpenedModal = true;
        }

        this.onSendStatus.emit(this.integrationToroPi);
    }

    /**
     * Faz o redirect coforme o parametro passado
     *
     * @param uri
     */
    public redirectToUri(uri: string) {
        this.router.navigate([uri]);
    }

    public closeModal() {
        this.modalWelcomePi.hide();
        this.hideModal.emit(false);

        const isCompleteSuitability = StorageService.getLocalItem('@suitability:is_complete_welcome_pi');

        if (isCompleteSuitability === 'yes') {
            StorageService.setLocalItem('@common:is_show_movie_toro_pi', 'no');
        }
    }

    /**
     * Valida se é o primeiro login do usuário Pi
     */
    private async storageToroPi() {

        const loginToroPi = await StorageService.getLocalItem('@common:is_first_login_toro_pi');

        this.integrationToroPi.firstLogin = !!loginToroPi ? 'no' : 'yes';

        StorageService.setLocalItem('@common:is_first_login_toro_pi', this.integrationToroPi.firstLogin);

    }

    /**
     * Apresentar modal com vídeo após cadadastros Agreeement e Suitability
     */
    private async showMovieToroPi() {
        const showMovieToroPi = await StorageService.getLocalItem('@common:is_show_movie_toro_pi');

        this.integrationToroPi.isShowMovie = (showMovieToroPi === 'yes')
            && this.integrationToroPi.isAgreement
            && this.integrationToroPi.isSuitability;

        if (this.integrationToroPi.isShowMovie) {
            this.modalWelcomePi.show();
        }
    }
}
